var map = {
	"./cherri.png": "k2jd",
	"./favicon.png": "ZURh",
	"./img.png": "UBpp",
	"./img1 - Copy.png": "Olm3",
	"./img1.png": "fgq6",
	"./knowledgebank.png": "XztQ",
	"./laraCRUD.png": "i2v5",
	"./peoplepower.png": "fvrj",
	"./simplephpmvc.png": "dm+9",
	"./technical-support.png": "l0kF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BEjn";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.png$
// module id = BEjn
// module chunks = 1